import posthog from 'posthog-js'

const POSTHOG_KEY = (import.meta.env.VITE_POSTHOG_KEY as string) || ''
const POSTHOG_HOST = (import.meta.env.VITE_POSTHOG_HOST as string) || 'https://us.i.posthog.com'

let isInitialized = false

const PII_BLACKLIST = [
  'name',
  'email',
  'phone',
  'address',
  'notes',
  'description',
  'title',
  'comment',
  'token',
  'public_token',
  'logo_path',
  'business_name',
  'contact_name',
  'logo',
  'address_line1',
  'job_address',
  'authorization',
  'apikey',
  'service_role',
]

/**
 * Recursively sanitizes properties, stripping blacklisted keys.
 */
export function sanitizeProperties(properties: unknown): unknown {
  if (properties === null || properties === undefined) {
    return properties
  }

  if (Array.isArray(properties)) {
    return properties.map(sanitizeProperties)
  }

  if (typeof properties === 'object') {
    const result: Record<string, unknown> = {}
    const obj = properties as Record<string, unknown>
    for (const key of Object.keys(obj)) {
      const lowerKey = key.toLowerCase()
      const isSensitive = PII_BLACKLIST.some(
        (term) => lowerKey === term || lowerKey.includes(term)
      )
      if (isSensitive) {
        continue
      }
      result[key] = sanitizeProperties(obj[key])
    }
    return result
  }

  return properties
}

export function initAnalytics() {
  if (POSTHOG_KEY && !isInitialized) {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      autocapture: false,
      capture_pageview: false,
      persistence: 'localStorage',
    })
    isInitialized = true
  }
}

export function trackEvent(event: string, properties?: Record<string, unknown>) {
  if (!isInitialized) return
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const safeProperties = sanitizeProperties(properties) as Record<string, any> | undefined
  posthog.capture(event, safeProperties)
}

export function identifyUser(userId: string, properties?: Record<string, unknown>) {
  if (!isInitialized) return
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const safeProperties = sanitizeProperties(properties) as Record<string, any> | undefined
  posthog.identify(userId, safeProperties)
}

export function resetAnalytics() {
  if (!isInitialized) return
  posthog.reset()
}
